import { Flex, FlexProps } from 'rebass';
import React, { useCallback } from 'react';

type FormProps = FlexProps & {
  children: React.ReactNode;
};

const Form = (props: FormProps): JSX.Element => {
  const onSubmit = useCallback(
    (e: any) => {
      props.onSubmit?.(e);
      e.preventDefault();
    },
    [props.onSubmit]
  );
  return (
    <Flex
      as="form"
      p={4}
      flexGrow={1}
      flexDirection="column"
      {...(props as any)}
      sx={{ gap: 3, ...props.sx }}
      onSubmit={onSubmit}
    >
      {props.children}
    </Flex>
  );
};

export default Form;
